import { VerticalContainer } from '@american-autonomy/ag-ui';

import BodyText from 'components/text/BodyText';
import CaptionText from 'components/text/CaptionText';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const StatItem: FunctionComponent<Props> = ({
    className = '',
    isHighlighted = false,
    label,
    testId = TEST_ID,
    unit = '',
    value
}) => {
    const displayValue = unit ? `${value} ${unit}` : `${value}`;
    const highlightedClass = isHighlighted ? styles.highlighted : '';

    return (
        <VerticalContainer
            className={`${className} ${highlightedClass} ${styles.statItem}`}
            testId={testId}>
            <CaptionText className={styles.label} text={label} />

            <BodyText className={styles.value} text={displayValue} />
        </VerticalContainer>
    );
};

export default StatItem;
